import { render, staticRenderFns } from "./ActiveRemoteConnections.vue?vue&type=template&id=a35d10e2"
import script from "./ActiveRemoteConnections.vue?vue&type=script&lang=js"
export * from "./ActiveRemoteConnections.vue?vue&type=script&lang=js"
import style0 from "./ActiveRemoteConnections.vue?vue&type=style&index=0&id=a35d10e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports